import Head from "expo-router/head";
import { useContext } from "react";

import { LayoutContext, ScrollView } from "@/components";
import { WALMART_EVENTS } from "@/config/adConversionEvents";
import { brandName } from "@/config/brand";
import Glp1LandingPage, {
  type Glp1PartnerDisplay,
} from "@/landing-page/glp1/Glp1LandingPage";

const PARTNER_DISPLAY: Glp1PartnerDisplay = {
  name: "Walmart",
  brandColor: "$walmartBlue",
  trackingEvent: WALMART_EVENTS.visitedGlp1SplashScreen,
  providerId: "WM_CURAI",
  heroSubtitle:
    "Curai Health offers GLP-1 prescriptions to support your weight loss goals, with care from clinicians licensed in your state.",
  heroAltCareLink: {
    prompt: "Not here for GLP-1s?",
    linkCopy: "See all Curai care options.",
    href: "/walmart?origin=walmart-glp-1",
  },
};

export default function Glp1ProgramPage() {
  const { headerHeight } = useContext(LayoutContext);
  return (
    <>
      <Head>
        <title>{`GLP-1 Program — ${brandName}`}</title>
      </Head>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          paddingTop: headerHeight.current,
        }}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        backgroundColor="$backgroundGround"
      >
        <Glp1LandingPage partnerDisplay={PARTNER_DISPLAY} />
      </ScrollView>
    </>
  );
}
